export const aboutData = {
  brandName: "探花精选",
  slogan: "精品内容一站汇聚",
  introduction: `探花精选成立于2020年，是一家专注于高品质内容甄选与推荐的数字媒体平台。我们相信，在信息爆炸的时代，"筛选"比"获取"更有价值。每一天，我们的编辑团队都会从海量信息中精心挑选出最值得关注的内容，涵盖科技、文化、生活、设计等多个领域，为用户节省宝贵的时间，直达高价值信息。

我们的名字"探花"取自中国传统文化中"探花及第"的典故，寓意着对卓越品质的不懈追求。我们不仅是在推荐内容，更是在传递一种生活态度——在纷繁复杂的世界中，保持好奇、保持品味、保持独立思考的能力。`,
  mission: "让每一位追求品质的用户，都能在这里找到属于自己的精神食粮。",
  values: [
    { title: "品质优先", description: "每一篇推荐内容都经过编辑团队严格筛选，我们宁缺毋滥，绝不为了数量牺牲质量。" },
    { title: "独立思考", description: "我们不受商业利益左右，坚持从用户角度出发，提供真实、客观、有深度的内容推荐。" },
    { title: "持续探索", description: "世界在变化，好内容也在不断涌现。我们始终保持好奇心，持续发现新的优质资源。" },
  ],
  teamIntro: "探花精选团队由一群热爱生活、痴迷品质的内容创作者组成。我们的编辑来自不同的专业背景——文学、设计、科技、艺术——但都怀揣着同一个信念：好的内容值得被更多人看到。",
  milestones: [
    { year: "2020", event: "探花精选正式上线，以「精选推荐」为核心栏目起步" },
    { year: "2021", event: "推出「深度评测」栏目，建立专业评测体系" },
    { year: "2022", event: "用户突破50万，「独家发现」栏目成为平台特色" },
    { year: "2023", event: "上线「品质生活」和「科技数码」频道，内容矩阵持续扩展" },
    { year: "2024", event: "推出「文化阅读」频道，深化人文内容布局" },
    { year: "2025", event: "用户突破200万，获评年度最佳内容推荐平台" },
    { year: "2026", event: "全面升级内容体系，推出个性化推荐功能，持续引领精品内容消费趋势" },
  ],
  testimonials: [
    {
      name: "张先生",
      role: "互联网从业者",
      content: "探花精选已经成为我每天早上必看的网站。它帮我过滤了大量无效信息，让我能在最短的时间内获取最有价值的内容。编辑的品味真的很好！",
    },
    {
      name: "李女士",
      role: "设计师",
      content: "作为一个设计师，我特别欣赏探花精选对美学的坚持。不仅是内容质量高，整个网站的阅读体验也做得非常出色，让人愿意花时间沉浸其中。",
    },
    {
      name: "王同学",
      role: "研究生",
      content: "探花精选的深度评测和文化阅读栏目对我的学习帮助很大。很多文章都提供了独特的视角和深度的分析，这是我其他地方找不到的。",
    },
  ],
  contact: {
    email: "hello@pkgogo.cn",
    wechat: "探花精选",
    weibo: "@探花精选官方",
    address: "北京市朝阳区建国路88号SOHO现代城A座1508室",
    phone: "010-8888-6666",
  },
  faqs: [
    {
      question: "探花精选的内容来源是什么？",
      answer: "我们的内容由专业编辑团队独立创作和甄选。编辑团队每天从全球范围内筛选优质信息源，并结合自身专业背景进行深度加工和原创撰写，确保每一篇内容的独特性和价值。",
    },
    {
      question: "如何判断一篇文章是否值得推荐？",
      answer: "我们有一套严格的五维评估体系：信息价值（文章是否提供了新知或独特见解）、深度（分析是否透彻全面）、可读性（表达是否清晰流畅）、时效性（内容是否与当下相关）、独特性（视角是否与众不同）。只有在这五个维度上都达到标准的文章，才会被推荐给我们的读者。",
    },
    {
      question: "我可以投稿给探花精选吗？",
      answer: "非常欢迎！我们一直在寻找有独特观点和专业背景的撰稿人。如果您有优质的内容想要与探花精选的读者分享，请将您的稿件或选题提案发送至我们的投稿邮箱，编辑团队会在7个工作日内回复。",
    },
    {
      question: "探花精选的内容是否收费？",
      answer: "目前探花精选的所有内容均免费开放阅读。我们希望通过降低获取优质内容的门槛，让更多人受益。未来我们可能会推出增值服务，但核心内容将始终保持免费。",
    },
    {
      question: "如何第一时间获取探花精选的最新推荐？",
      answer: "您可以通过关注我们的微信公众号「探花精选」、微博「@探花精选官方」来获取每日精选推送。我们也在开发邮件订阅功能，届时您可以通过邮件接收每周精选内容汇总。",
    },
  ],
};